import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle"; // Includes base styles
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "swiper/css/autoplay"; // Import styles for autoplay

import { Navigation, Pagination, EffectCoverflow, Autoplay } from "swiper/modules";

import "./slider.css";

// Importing images
import p3s1 from "../../Assets/project5/cover page.webp";
import p3s2 from "../../Assets/project6/rfid cover page.webp";
import p3s3 from "../../Assets/project7/cover page.webp";
import p3s4 from "../../Assets/project8/cover page.webp";
import p3s5 from "../../Assets/project9/d1.webp";
import p3s6 from "../../Assets/project10/p10cover page.webp";
import p3s7 from "../../Assets/project11/cover page.webp";
import p3s8 from "../../Assets/project12/cover page.webp";
import p3s9 from "../../Assets/project13/cover page.webp";
import p3s10 from "../../Assets/project14/cover page.webp";
import p3s11 from "../../Assets/project15/cover page.webp";
import p3s12 from "../../Assets/project16/cover page.webp";
import p3s13 from "../../Assets/project17/cover page.webp";

const Slider = ({ onSlideClick }) => {
  // Array of imported images
  const slides = [p3s1, p3s2, p3s3, p3s4, p3s5, p3s6, p3s7, p3s8, p3s9, p3s10, p3s11, p3s12, p3s13];

  // Function to handle scroll on tile click
  const handleSlideClick = (index) => {
    onSlideClick(index); // Call the passed function if needed
    window.scrollBy({
      top: 400, // Scrolls down by 400 pixels
      behavior: "smooth", // Smooth scrolling
    });
  };

  return (
    <div className="custom-swiper-container">
      <div className="more-projects">
        <p>More Projects</p>
      </div>
      <Swiper
        modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
        effect="coverflow"
        grabCursor
        centeredSlides
        loop
        slidesPerView="auto"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        speed={1000}
        pagination={{ clickable: true }}
        navigation
      >
        {slides.map((image, index) => (
          <SwiperSlide key={index} className="tranding-slide">
            <div
              className="tranding-slide-img"
              onClick={() => handleSlideClick(index)} // Scroll down and handle click
              style={{ cursor: "pointer" }}
            >
              <img src={image} alt={`Slide ${index + 1}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
